var map = {
	"./payment-box-icon-01.png": 2923,
	"./payment-box-icon-02.png": 3670,
	"./payment-box-icon-03.png": 6844,
	"./payment-box-icon-04.png": 6210,
	"./payment-box-icon-05.png": 231,
	"./payment-box-icon-06.png": 9745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;